<template>
  <div class="hello">
    <div class="search container-fluid">
      <div class="search-bars">
        <input class="search-input" @input="searchUtilisateurs(currentPage)" v-model="searchTerm" type="text" placeholder="Rechercher un utilisateur...">
        <div class="affaire-search-inline">
          <input class="search-input" v-model="affaireTerm" type="text" placeholder="Rechercher par N° d'affaire..." @keyup.enter="triggerSearch" @input="onAffaireInput">
          <input class="search-input" v-model="commandeTerm" type="text" placeholder="Rechercher par N° de commande..." @keyup.enter="triggerSearch" @input="onAffaireInput">
          <select class="search-input" v-model="period" @change="onPeriodChange">
            <option value="">Toutes périodes</option>
            <option value="aujourd_hui">Aujourd'hui</option>
            <option value="hier">Hier</option>
            <option value="semaine_cours">Semaine en cours</option>
            <option value="semaine_precedente">Semaine précédente</option>
            <option value="mois_cours">Mois en cours</option>
            <option value="mois_precedent">Mois précédent</option>
            <option value="mois_suivant">Mois suivant</option>
            <option value="mois_flottant">Mois flottant</option>
            <option value="deux_derniers_mois">Deux derniers mois</option>
            <option value="annee_precedente">Année précédente</option>
            <option value="annee_cours">Année en cours</option>
            <option value="personnalisee">Personnalisée</option>
          </select>
          <template v-if="period === 'personnalisee'">
            <input type="date" class="search-input" v-model="startDate" @change="triggerSearch">
            <input type="date" class="search-input" v-model="endDate" @change="triggerSearch">
          </template>
          <button class="btn-affaire" @click="triggerSearch" :disabled="!canSearch">Rechercher</button>
          <button v-if="searchDone" class="btn-affaire btn-clear" @click="clearFilters">Effacer</button>
        </div>
      </div>

      <div v-if="affaireLoading" class="loader"><div id="loading"></div></div>

      <template v-if="searchDone && !searchLoading">
        <p class="filtres-actifs" v-if="affaireTerm.trim() || commandeTerm.trim() || period">
          Filtres actifs :
          <span v-if="affaireTerm.trim()">Affaire : <strong>{{ affaireTerm.trim() }}</strong></span>
          <span v-if="affaireTerm.trim() && (commandeTerm.trim() || period)"> &mdash; </span>
          <span v-if="commandeTerm.trim()">Commande : <strong>{{ commandeTerm.trim() }}</strong></span>
          <span v-if="commandeTerm.trim() && period"> &mdash; </span>
          <span v-if="period && period !== 'personnalisee'">Période : <strong>{{ periodLabel }}</strong></span>
          <span v-if="period === 'personnalisee' && startDate">du <strong>{{ startDate }}</strong> au <strong>{{ endDate }}</strong></span>
        </p>
        <template v-if="searchResults.length > 0">
          <!-- Groupé par utilisateur (quand affaire renseignée) -->
          <table v-if="groupedBy === 'user'" class="affaire-results-table utilisateursListe mt-3 mb-3">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Email</th>
                <th>Total heures</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in searchResults" :key="row.id"
                  :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'">
                <td>{{ row.nom }}</td>
                <td>{{ row.prenom }}</td>
                <td>{{ row.email }}</td>
                <td><strong>{{ formatDureeHHMM(row.total_heures) }}</strong></td>
              </tr>
            </tbody>
          </table>
          <!-- Groupé par affaire (quand seule la période est renseignée) -->
          <table v-else class="affaire-results-table utilisateursListe mt-3 mb-3">
            <thead>
              <tr>
                <th>N° Affaire</th>
                <th>Désignation</th>
                <th>Client</th>
                <th>Total heures</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in searchResults" :key="row.affaire"
                  :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'">
                <td>{{ row.affaire }}</td>
                <td>{{ row.desa }}<template v-if="row.desa2"><br>{{ row.desa2 }}</template><template v-if="row.desa3"><br>{{ row.desa3 }}</template></td>
                <td>{{ row.client }}</td>
                <td><strong>{{ formatDureeHHMM(row.total_heures) }}</strong></td>
              </tr>
            </tbody>
          </table>
        </template>
        <p v-else class="no-result">Aucun résultat pour ces filtres.</p>
      </template>
    </div>
    <div v-if="nb_pages > 1" class="pagination container">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchUtilisateurs(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>
    <div class="links container-fluid">
     
    </div>
  
    <table class="utilisateursListe mb-5">
      <thead>
        <tr>
          <th></th>
          <th>Nom</th>
          <th>Prénom</th>
          <th>Email</th>
          <!--  <th>Espace perso</th> -->
        </tr>
      </thead>
      <tbody>
        <!-- Check if the articles array is empty -->
        <template v-if="utilisateurs.length === 0">
          <tr>
            <td colspan="8" class="text-center">Pas de productions enregistrés.</td>
          </tr>
        </template>
      
        <!-- Render table rows for each article -->
        <template v-else>
            <RouterLink v-for="(utilisateur, index) in utilisateurs" :key="utilisateur.id" :to="'/production/' + utilisateur.id"> 
              <tr class="utilisateurs" :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'"> 

                <td>
                  <div class="profil-picture">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
                    </svg>
                  </div>
                </td>
                <td>{{ utilisateur.nom }}</td>
                <td>{{ utilisateur.prenom }}</td>
                <td>{{ utilisateur.email }}</td>
              
              <!--    <td>
                  <RouterLink :to="getUserLink(utilisateur)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-fill" viewBox="0 0 16 16">
                  <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                  </svg></RouterLink>
                </td> -->
              </tr>
            </RouterLink>
        </template>
      </tbody>
      
    </table>
   
      <div v-if="nb_pages > 1" class="pagination container">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchUtilisateurs(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>
  </div>



</template>

<script>
import axios from '@/components/axiosConfig.js'
import { formatDureeHHMM } from '@/utils/duree.js'


export default {
  data() {
    return {
      utilisateurs: [],
      nb_pages:1,
      currentPage: 1,
      searchTerm: '',
      isLoading: false,
      affaireTerm: '',
      commandeTerm: '',
      period: '',
      startDate: '',
      endDate: '',
      searchResults: [],
      searchLoading: false,
      searchDone: false,
      groupedBy: 'affaire',
    }
  },
  mounted() {
    

      this.currentPage = parseInt(this.$route.query.page) || 1;
      this.searchTerm = this.$route.query.searchTerm || '';

      this.searchUtilisateurs(this.currentPage);

  }, 
  watch: {
    $route(to) {
      this.currentPage = parseInt(to.query.page) || 1;
      this.searchTerm = to.query.searchTerm || '';

      this.searchUtilisateurs(this.currentPage);
    }

    
  },
  computed: {
    canSearch() {
      return this.affaireTerm.trim() !== '' || this.commandeTerm.trim() !== '' || (this.period !== '' && this.period !== 'personnalisee') || (this.period === 'personnalisee' && this.startDate && this.endDate);
    },
    periodLabel() {
      const labels = {
        aujourd_hui: "Aujourd'hui", hier: 'Hier',
        semaine_cours: 'Semaine en cours', semaine_precedente: 'Semaine précédente',
        mois_cours: 'Mois en cours', mois_precedent: 'Mois précédent',
        mois_suivant: 'Mois suivant', mois_flottant: 'Mois flottant',
        deux_derniers_mois: 'Deux derniers mois',
        annee_precedente: 'Année précédente', annee_cours: 'Année en cours',
        personnalisee: 'Personnalisée',
      };
      return labels[this.period] || '';
    },
  },
  methods: {
    formatDureeHHMM,
    triggerSearch() {
      if (!this.canSearch) return;
      this.searchLoading = true;
      this.searchDone = true;
      axios.post('https://www.simef.fr/espace-client/api/getProductionsCroise.php', {
        affaire:   this.affaireTerm.trim(),
        commande:  this.commandeTerm.trim(),
        startDate: this.startDate,
        endDate:   this.endDate,
      })
      .then(response => {
        this.searchResults = response.data.results || [];
        this.groupedBy     = response.data.grouped || 'affaire';
      })
      .catch(error => {
        console.error(error);
        this.searchResults = [];
      })
      .finally(() => {
        this.searchLoading = false;
      });
    },
    onAffaireInput() {
      if (!this.affaireTerm.trim() && !this.commandeTerm.trim() && this.period === '') {
        this.clearFilters();
      }
    },
    clearFilters() {
      this.affaireTerm  = '';
      this.commandeTerm = '';
      this.period       = '';
      this.startDate    = '';
      this.endDate      = '';
      this.searchResults = [];
      this.searchDone   = false;
    },
    onPeriodChange() {
      const today = new Date();
      const fmt = d => d.toISOString().slice(0, 10);
      const monday = (d) => {
        const day = d.getDay() || 7;
        const m = new Date(d);
        m.setDate(d.getDate() - day + 1);
        return m;
      };
      switch (this.period) {
        case '':
          this.startDate = '';
          this.endDate = '';
          this.clearFilters();
          return;
        case 'aujourd_hui': {
          this.startDate = fmt(today);
          this.endDate = fmt(today);
          break;
        }
        case 'hier': {
          const h = new Date(today); h.setDate(today.getDate() - 1);
          this.startDate = fmt(h); this.endDate = fmt(h);
          break;
        }
        case 'semaine_cours': {
          const lun = monday(today);
          const dim = new Date(lun); dim.setDate(lun.getDate() + 6);
          this.startDate = fmt(lun); this.endDate = fmt(dim);
          break;
        }
        case 'semaine_precedente': {
          const lunPrec = monday(today); lunPrec.setDate(lunPrec.getDate() - 7);
          const dimPrec = new Date(lunPrec); dimPrec.setDate(lunPrec.getDate() + 6);
          this.startDate = fmt(lunPrec); this.endDate = fmt(dimPrec);
          break;
        }
        case 'mois_cours': {
          const d1 = new Date(today.getFullYear(), today.getMonth(), 1);
          const d2 = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          this.startDate = fmt(d1); this.endDate = fmt(d2);
          break;
        }
        case 'mois_precedent': {
          const d1 = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const d2 = new Date(today.getFullYear(), today.getMonth(), 0);
          this.startDate = fmt(d1); this.endDate = fmt(d2);
          break;
        }
        case 'mois_suivant': {
          const d1 = new Date(today.getFullYear(), today.getMonth() + 1, 1);
          const d2 = new Date(today.getFullYear(), today.getMonth() + 2, 0);
          this.startDate = fmt(d1); this.endDate = fmt(d2);
          break;
        }
        case 'mois_flottant': {
          const d1 = new Date(today); d1.setDate(today.getDate() - 30);
          this.startDate = fmt(d1); this.endDate = fmt(today);
          break;
        }
        case 'deux_derniers_mois': {
          const d1 = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const d2 = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          this.startDate = fmt(d1); this.endDate = fmt(d2);
          break;
        }
        case 'annee_precedente': {
          this.startDate = `${today.getFullYear() - 1}-01-01`;
          this.endDate = `${today.getFullYear() - 1}-12-31`;
          break;
        }
        case 'annee_cours': {
          this.startDate = `${today.getFullYear()}-01-01`;
          this.endDate = `${today.getFullYear()}-12-31`;
          break;
        }
        case 'personnalisee':
          return;
      }
      this.triggerSearch();
    },
    searchUtilisateurs(page) {
      this.isLoading = true; // Show loader
      axios.get(`https://www.simef.fr/espace-client/api/getUtilisateursProd.php?page=${page}&searchTerm=${this.searchTerm}`)
        .then(response => {
          this.utilisateurs = response.data.utilisateurs;
          this.nb_pages = response.data.nb_pages;
          this.currentPage = page;

        })
        .catch(error => {
          console.error(error);
          

        })
        .finally(() => {
          this.isLoading = false; // Hide loader
        });

        this.$router.push({
          query: {
            page: page,
            searchTerm: this.searchTerm,
          }
        });
    },
  
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;

  .search-bars {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
  }

  .search-input {
    width: 260px;
    max-width: 100%;
    padding: 10px 14px !important;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
    box-sizing: border-box;
  }

  .affaire-search-inline {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }

  .btn-affaire {
    padding: 10px 16px;
    margin-top: 0 !important;
    background-color: #2b358d;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.95rem;
    white-space: nowrap;
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    &.btn-clear {
      background-color: #888;
    }
  }

  .affaire-results-table {
    width: 100%;
    border-collapse: collapse;
    th {
      background-color: #2b358d;
      color: white;
      font-weight: 600;
      padding: 10px 12px;
      text-align: left;
    }
    td {
      padding: 10px 12px;
      border-bottom: 1px solid #e0e0e0;
    }
  }

  .filtres-actifs {
    font-size: 0.9rem;
    color: #555;
    margin-bottom: 10px;
    span { margin: 0 2px; }
  }

  .no-result {
    color: #888;
    font-style: italic;
    text-align: center;
    margin-top: 10px;
  }
</style>
